import { computed } from 'vue';
import { useField, Field } from 'vee-validate';


export default {
  __name: 'ZipCodeField',
  setup(__props, { expose }) {
  expose();

const { value: zipCode, errors, errorMessage } = useField('personalInformation.zipCode');

const formattedZipCode = computed({
    get: () => zipCode.value,
    set: (newVal) => {
        let numericValue = newVal.replace(/\D/g, '').slice(0, 5);
        if (numericValue.length >= 2) {
            numericValue = `${numericValue.slice(0, 2)}-${numericValue.slice(2)}`;
        }
        zipCode.value = numericValue;
    },
});

const __returned__ = { zipCode, errors, errorMessage, formattedZipCode, computed, get useField() { return useField }, get Field() { return Field } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}